// extracted by mini-css-extract-plugin
export var box = "_8k-1";
export var checkboxRow = "_8k-8";
export var checked = "_8k-2";
export var descriptionSpacer = "_8k-a";
export var disabled = "_8k-3";
export var icon = "_8k-6";
export var input = "_8k-0";
export var labelSpacer = "_8k-9";
export var medium = "_8k-5";
export var small = "_8k-4";
export var text = "_8k-7";